import { useTranslation } from 'react-i18next';

import { Icon, Tooltip } from '~/components';
import { Field, Input } from '~/components/Form';
import { srOnlyStyle } from '~/styles/utilities.css';
import { clsx } from '~/styles/utils';

import { useLineContext } from '../../SectionLines/SectionLines.context';
import { iconStyle, iconWrapperStyle, wrapperStyle } from './ProductName.css';

type Props = {
  value: string;
};

export const ProductName = ({ value }: Props) => {
  const { isMobile } = useLineContext();

  const { t } = useTranslation(['lines']);

  return (
    <Field.Root>
      <Field.Label className={clsx(!isMobile && srOnlyStyle)}>{t('lines:productName.label')}</Field.Label>

      <div className={wrapperStyle}>
        <Input disabled value={value} />

        <div className={iconWrapperStyle}>
          <Tooltip content={t('lines:productName.tooltip')}>
            <span className={iconStyle}>
              <Icon name="Lock" size={20} />
            </span>
          </Tooltip>
        </div>
      </div>
    </Field.Root>
  );
};
